import type { RequestEvent } from "@sveltejs/kit";
import { UIApiBase } from "@thehood/svlib";
import { utils } from "./utils";

export class UIApi extends UIApiBase {
  protected host = "http://127.0.0.1:5173";
  public input!: RequestEvent;
  constructor(headers?: Record<string, string | number>, showlog = true) {
    super(headers, showlog);
    this.host = utils.getHost();
  }

  // protected afterResponse(response: Response): void {
  //   if (this.input) {
  //     setCMSCookies(response, this.input, { httpOnly: true, path: "/", secure: !dev });
  //   }
  // }
}

export const uiApi = new UIApi();
